import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ toggleSidebar }) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const logOut = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      sessionStorage.removeItem("token");
      navigate("/login");
      enqueueSnackbar("Logout Successfully...", { variant: "success" });
    }
  };
  return (
    <header className="bg-white shadow-md p-4 flex justify-between items-center">
      <button
        onClick={toggleSidebar}
        className="md:hidden text-gray-800 focus:outline-none"
      >
        ☰
      </button>
      <h2 className="text-xl font-semibold">Admin Panel</h2>
      <div>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded"
          onClick={logOut}
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
